import { CheckCircle, Star, Trash2 } from 'lucide-react'
import type Opportunity from '@/types/serializers/Opportunity'
import { Card, CardContent } from "@/components/ui/card.tsx";
import { Button } from "@/components/ui/button.tsx";

interface ActionBarProps {
    opportunity: Opportunity
    onRelevant: () => void
    onStar: () => void
    onDiscard: () => void
}

export default function ActionBar({opportunity, onRelevant, onStar, onDiscard}: ActionBarProps) {
    return (
        <Card className="mb-6">
            <CardContent>
                <div className="text-sm text-slate-600 dark:text-slate-400 mb-3">
                    Qualify this opportunity
                </div>
                <div className="flex items-center space-x-3">
                    <button
                        onClick={onRelevant}
                        className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                            opportunity.relevant
                                ? 'bg-green-200 dark:bg-green-800 ring-2 ring-green-400 text-green-800 dark:text-green-200'
                                : 'bg-slate-100 dark:bg-dark-bg-600 hover:bg-slate-200 dark:hover:bg-dark-bg-500 text-slate-700 dark:text-slate-300'
                        }`}
                    >
                        <CheckCircle className="w-4 h-4"/>
                        <span>Relevant</span>
                    </button>
                    <button
                        onClick={onStar}
                        className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                            opportunity.starred
                                ? 'bg-yellow-200 dark:bg-yellow-800 ring-2 ring-yellow-400 text-yellow-800 dark:text-yellow-200'
                                : 'bg-slate-100 dark:bg-dark-bg-600 hover:bg-slate-200 dark:hover:bg-dark-bg-500 text-slate-700 dark:text-slate-300'
                        }`}
                    >
                        <Star className="w-4 h-4"/>
                        <span>Star</span>
                    </button>

                    <Button
                        onClick={onDiscard}
                        disabled={opportunity.discarded}
                    >
                        <Trash2 className="w-4 h-4"/>
                        <span>Discard</span>
                    </Button>
                </div>
            </CardContent>
        </Card>
    )
}